import { render, staticRenderFns } from "./_bottom.vue?vue&type=template&id=620fcdcc"
import script from "./_bottom.vue?vue&type=script&lang=js"
export * from "./_bottom.vue?vue&type=script&lang=js"
import style0 from "./_bottom.vue?vue&type=style&index=0&id=620fcdcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DealerTisk: require('/root/workspace/web-company_Yo6Q/components/dealer/head/dealerTisk.vue').default,DealerModule: require('/root/workspace/web-company_Yo6Q/components/dealer/head/dealerModule.vue').default})
